<template>
  <footer class="footer">
      <div class="container">
        <div class="content has-text-centered is-small">
          <p>
            <toggle-dark-theme></toggle-dark-theme>
          </p>
          <p>
            &copy; {{ currentYear }} leaguepoints.lol - Data provided by the official League of Legends API
          </p>
          <p>
            Leaguepoints. isn’t endorsed by Riot Games and doesn’t reflect the views or opinions of Riot Games or anyone officially involved in producing or managing League of Legends. League of Legends and Riot Games are trademarks or registered trademarks of Riot Games, Inc. League of Legends © Riot Games, Inc.
          </p>
        </div>
      </div>
    </footer>
</template>

<script>
import ToggleDarkTheme from './ToggleDarkTheme'

export default {
  components: {
    ToggleDarkTheme,
  },

  computed: {
    currentYear () {
      return (new Date()).getFullYear()
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../sass/variables'
@import '~bulma/sass/utilities/variables'

.footer
  background-color: $primary
  margin-top: 4rem
  padding-top: 1.25rem
  padding-bottom: 1.25rem

  .content
    color: white
</style>



// WEBPACK FOOTER //
// AppFooter.vue?78527237